import { useTrackingEvents } from '~/composables/tracking-events/use-tracking-events'
import { useUserStore } from '#lib/stores'
import { TrackingEventName } from '~/enums'
import type { PromotionalEngagement, TrackingPromotion } from '~/types/tracking-events'

export function usePromotionalEngagement() {
  const userStore = useUserStore()
  const { trackingEvents } = useTrackingEvents()

  const trackingPromotionViewed = (values: PromotionalEngagement) => {
    const params: TrackingPromotion = {
      user_id: userStore.data.id,
      promotion_id: values.promotionId,
      promotion_name: values.promotionName,
    }
    trackingEvents(TrackingEventName.PromotionViewed, params)
  }

  const trackingPromotionClicked = (values: PromotionalEngagement) => {
    const params: TrackingPromotion = {
      user_id: userStore.data.id,
      promotion_id: values.promotionId,
      promotion_name: values.promotionName,
    }
    trackingEvents(TrackingEventName.PromotionClicked, params)
  }

  return {
    trackingPromotionViewed,
    trackingPromotionClicked,
  }
}
